import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AppComponent } from './app.component';
import { TraderBridgeComponent } from './trader-bridge/trader-bridge.component';

const routes: Routes = [
	{
		path: 'account',
		component: AppComponent,
		children: [
			{
				path: 'bridge',
				component: TraderBridgeComponent,
			},
		],
	},
];

@NgModule({
	imports: [RouterModule.forRoot(routes)],
	exports: [RouterModule],
})
export class AppRoutingModule {}
